import React, { useState, useEffect } from "react";
import { CardBody, InputGroup, InputGroupAddon, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { Link } from "react-router-dom";
import TeamanicsButton from "../../../../buttoncomponent/TeamanicsButton";
import { isNullOrEmpty } from "../../../../config/ENV";
import { Constants } from "../../../../constants/constantValues";
import { StorageValues } from "../../../../constants/storageValues";
import { ProfileService } from "../../../../services/ProfileService";
import { StorageService } from "../../../../services/StorageService";
import { showSalary } from "../../../../utilities/showsalary";
import { Stringutility } from "../../../../utilities/stringutility";
import { FaAngleUp } from "react-icons/fa";


const FindJobsDescription = (props) => {
  const [jobResponseList, setJobResponseList] = useState([]);
  const [jobResponseModalList, setJobResponseModalList] = useState([]);
  const {id,selectedId,jobId, responseList ,ModalLong } = props;
  const [showFirstData, setShowFirstData] = useState(true);
  const [showTopBtn, setShowTopBtn] = useState(false);

  const [ModalBase,setModalBase]=useState(false);
 
  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 400) {
        setShowTopBtn(true);
      } else {
        setShowTopBtn(false);
      }
    });
  }, []);
  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  useEffect(() => {
    
    setModalBase(ModalLong)
    setShowFirstData(true)
        var x = responseList.filter((item) => item.jobId === jobId);
    setJobResponseList(x);
    var y = responseList.filter((item) => item.id === selectedId);
    setJobResponseModalList(y)

    if (x) {
      
      const tabButtons = document.getElementById("tab-buttons");
      const tabPanels = document.getElementById("tab-panels");
  
      if (tabButtons && tabPanels) {
       
        changeTab(0);
      }}
    
  }, [jobId,ModalLong]);

  // useEffect(() => {
  //   setModalBase(ModalLong)
  //   console.log("useeffect");
  // }, [ModalLong]);

  const getJobBenefits = (moBenefits) => {
    const bList = [];
    if (moBenefits != null) {
      if (moBenefits.cobra == true) {
        bList.push("Cobra");
      }

      if (moBenefits.Disability == true) {
        bList.push("Disability");
      }

      if (moBenefits.medicalLeave == true) {
        bList.push("Medical Leave");
      }

      if (moBenefits.minimumWage == true) {
        bList.push("Minimum Wage");
      }

      if (moBenefits.overtime == true) {
        bList.push("Overtime");
      }

      if (moBenefits.unEmploymentBenefit == true) {
        bList.push("Unemployment Benefits");
      }

      if (moBenefits.WorkerCompensation == true) {
        bList.pushd("Workers Compensation");
      }

      if (moBenefits.bonusPay == true) {
        bList.push("Bonus Pay");
      }

      if (moBenefits.compensation401k == true) {
        bList.push("401k");
      }

      if (moBenefits.stockOption == true) {
        bList.push("Stock options");
      }

      if (moBenefits.health == true) {
        bList.push("Helth");
      }

      if (moBenefits.dental == true) {
        bList.push("Dental");
      }

      if (moBenefits.vision == true) {
        bList.push("Vision");
      }

      if (moBenefits.lifeInsurance == true) {
        bList.push("Life Insurance");
      }

      if (moBenefits.paidHoliday == true) {
        bList.push("Paid Holidays");
      }

      if (moBenefits.paidSickTime == true) {
        bList.push("Paid Sick Time");
      }

      if (moBenefits.paidVacation == true) {
        bList.push("Paid Vacation");
      }

      if (moBenefits.flexibleHour == true) {
        bList.push("Flexible Hours");
      }

      if (moBenefits.parentalLeave == true) {
        bList.push("Parental Leave");
      }

      if (moBenefits.empDiscount == true) {
        bList.push("Employee Discounts");
      }

      if (moBenefits.profDeveAssistance == true) {
        bList.push("Professional Development Assistance");
      }
      if (moBenefits.tuition == true) {
        bList.push("Tuition");
      }
      return bList.join(", ");
    }
  };

  const checkJobSalary = (jobResponse) => {
    if (jobResponse !== null) {
      let salaryMin = jobResponse.salaryMin;
      let salaryMax = jobResponse.salaryMax;
      let salaryType = jobResponse.salaryType;

      if (salaryMin == 0 && salaryMax == 0) {
        return <></>;
      } else if (salaryMin !== 0 && salaryMax == 0) {
        return <>{"$" + showSalary(salaryMin, salaryMin, salaryMax)}</>;
      } else if (salaryMin == 0 && salaryMax !== 0) {
        return <> {"$" + showSalary(salaryMax, salaryMin, salaryMax)}</>;
      } else if (salaryMin == salaryMax) {
        return <> {"$" + showSalary(salaryMin, salaryMin, salaryMax)}</>;
      } else {
        return (
          <>
            {" "}
            {"$" +
              showSalary(salaryMin, salaryMin, salaryMax) +
              "-" +
              "$" +
              showSalary(salaryMax, salaryMin, salaryMax)}
          </>
        );
      }
    }
  };

  const showSalaryType = (salaryType) => {
    if (salaryType !== null) {
      
      if (salaryType != null) {
        if (salaryType.key === "HOURLY") {
          return "hour";
        } else if (salaryType.key === "ANNUAL") {
          return "year";
        } else if (salaryType.key === "MONTHLY") {
          return "month";
        }
        return salaryType.value;
      }
    }
  };

  const showAdditionalbenefits = (benefits) => {
    if (!isNullOrEmpty(benefits)) {
      if (!isNullOrEmpty(benefits.perks)) {
        return benefits.perks;
      }
    }
  };

  const back = () => {
//alert(ModalBase)
// setModalBase(!ModalLong)
setModalBase(!ModalBase)
props.parentCallback(ModalBase);



   
  };

  // const showAccount =(account)=>{

  //   if(!isNullOrEmpty(account)){
  //       return account.name
  //   }

  //   }
  const showAccount = (account, address) => {
    const add = [];
    if (!isNullOrEmpty(account)) {
      add.push(account.name);
    }
    if (!isNullOrEmpty(address)) {
      if (!isNullOrEmpty(address.city)) {
        add.push(address.city);
      }
      if (!isNullOrEmpty(address.state)) {
        add.push(address.state);
      }
      if (!isNullOrEmpty(address.zipcode)) {
        add.push(address.zipcode);
      }
    }
    return add.join(", ");

  };

  function changeTab(index) {
    var tabButtons = document.getElementById("tab-buttons").children;
    var tabPanels = document.getElementById("tab-panels").children;

    // Remove the active utility classes from all tabs (bg-white, text-blue-600)
    // And hide all tab content (with the "hidden" utility)
    for (var i = 0; i < tabButtons.length; i++) {
      tabButtons[i].classList.remove("text-primary-white");
      tabButtons[i].classList.remove("bg-primary-blue");
      tabButtons[i].classList.add("text-primary-blue");
      tabPanels[i].classList.add("hidden");
    }

    // Add the active utility classes to the currently active tab (bg-white, text-blue-600)
    // And show the current tab content (remove the "hidden" utility)
    tabButtons[index].classList.remove("text-primary-blue");
    tabButtons[index].classList.add("text-primary-white");
    tabButtons[index].classList.add("bg-primary-blue");
    tabPanels[index].classList.remove("hidden");
  }
  function changeTabModal(index) {
    var tabButtons = document.getElementById("tab-buttonsModal").children;
    var tabPanels = document.getElementById("tab-panelsModal").children;

    // Remove the active utility classes from all tabs (bg-white, text-blue-600)
    // And hide all tab content (with the "hidden" utility)
    for (var i = 0; i < tabButtons.length; i++) {
      tabButtons[i].classList.remove("text-primary-white");
      tabButtons[i].classList.remove("bg-primary-blue");
      tabButtons[i].classList.add("text-primary-blue");
      tabPanels[i].classList.add("hidden");
    }

    // Add the active utility classes to the currently active tab (bg-white, text-blue-600)
    // And show the current tab content (remove the "hidden" utility)
    tabButtons[index].classList.remove("text-primary-blue");
    tabButtons[index].classList.add("text-primary-white");
    tabButtons[index].classList.add("bg-primary-blue");
    tabPanels[index].classList.remove("hidden");
  }
  const handleapplyjob = () => {
  
    const jobRequest = {
      jobId: jobId,
    };
    ProfileService.applyForJob(jobRequest).then((response) => {
      try {
        if (response.data != null) {
          if (response.status === 200) {
            Stringutility.showSuccessMessage(Constants.appliedJobSuccessfully)
            StorageService.removeItemInSessionStorage(StorageValues.APPLY_JOB);
            StorageService.removeItemInSessionStorage(StorageValues.JOB_ID);
            const timer = setTimeout(() => {
              window.location.href = "/dashboard";
            }, 2000);
          }
        }
      } catch (err) {
        console.error("applyForJob" + JSON.stringify(err));
      }
    });
  };

  return (
    <>





{(jobId == ""?jobResponseModalList:jobResponseList).length > 0 &&
        (jobId == ""?jobResponseModalList:jobResponseList).map((response, index) => {






          return (
            
              <div key={index}
              
                className="JobDetails JobDetails_Model  min-lg:col-span-3 
                                    min-lg:max-h-[70vh] 
                                    min-lg:px-4 max-lg:px-5
                                    hover:scrollbar-thin scrollbar-none pb-5"
              >
                <div className=" min-sm:col-span-2">
                  <div className="jobtitle">
                    <span className="text-[32px] font-semibold font-assistant ">
                      {response.publicTitle}
                    </span>
                    <p className="font-bold font-assistant">
                      {showAccount(response.account, response.address)}
                    </p>
                    
                    <div className="jdTag_immediate jdTag active mt-4 text-orange-400">
                      <svg
                        className="h-3 w-3 inline-block mr-1 "
                        fill="orange"
                        stroke="orange"
                        id="Layer_1"
                        data-name="Layer 1"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448.01 512"
                      >
                        <defs>
                          <style>.cls-1fill:orange;</style>
                        </defs>
                        <path
                          className="cls-1"
                          d="M224,0a32,32,0,0,0-32,32V51.2A160.07,160.07,0,0,0,64,208v18.8A192.46,192.46,0,0,1,15.5,354.4l-7.4,8.3A32,32,0,0,0,32,416H416a32,32,0,0,0,23.9-53.3l-7.4-8.3A192.27,192.27,0,0,1,384,226.8V208A160.07,160.07,0,0,0,256,51.2V32A32,32,0,0,0,224,0Zm45.3,493.3A64,64,0,0,0,288,448H160a64.06,64.06,0,0,0,109.3,45.3Z"
                          transform="translate(-0.02)"
                        ></path>
                      </svg>
                      <strong className="text-orange font-assistant">
                        Immediately hiring
                      </strong>
                    </div>
                  </div>

                  <div className="jobbrief_all border rounded-xl pt-3 pb-[10px] mb-3 mt-4 bg-primary-white/50 min-sm:-ml-1 font-assistant">
                    <div className="row">
                      {response.salaryMin !== 0 && response.salaryMax !== 0 ?  <div className="col-7">
                        <div className="jobbrief_salary  inline-block px-7 mb-3 ">
                          <strong className="text-[32px] font-semibold max-sm:text-[24px]">
                            {checkJobSalary(response)}
                          </strong>
                          <br />

                          {}
                          <span className="text-[18px] font-semibold font-assistant">
                            {showSalaryType(response.salaryType)}{" "}
                          </span>
                        </div>
                      </div>:<></>}
                     
                      <div className="col-5">
                        <div className="jobbrief_salary inline-block px-7 mt-1">
                          <strong className="text-[24px] font-semibold max-sm:text-[24px]">
                            {response.jobType.value}
                          </strong>
                          <br />
                          <span className="text-[18px] font-semibold font-assistant">
                            {response.workStatus.value}{" "}
                          </span>
                          <br />
                          <span className="text-sm font-light leading-3">
                            &nbsp;
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="jobbrief_info inline-block px-7 mb-3 min-sm:w-[100%]">
                      <strong className="text-[24px] font-semibold font-assistant">
                        Benefits
                      </strong>
                      <br />
                      <span className="text-sm inline-block min-sm:w-[81%] font-assistant">
                        {getJobBenefits(response.benefits)}
                      </span>
                      <br />
                      <div>
                        <strong className="text-[15px] font-semibold font-assistant">
                          Additional Benefits
                        </strong>
                        <span className="text-sm ml-1 inline-block min-sm:w-[81%] font-assistant">
                          {showAdditionalbenefits(response.benefits)}
                        </span>
                      </div>
                      
                      <br />
                      <a href={response.lpUrl}> <TeamanicsButton> Apply Now</TeamanicsButton></a>

                    </div>
                  </div>

                  <div className="jdTags flex flex-row min-sm:gap-3 ml-2 mb-4 max-sm:flex-col">
                    <div className="jdTag_immediate jdTag active mt-2 text-primary-blue">
                      <svg
                        className="h-4 w-4 inline-block mr-1 "
                        id="Layer_1"
                        data-name="Layer 1"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 640 512"
                      >
                        <defs>
                          <style></style>
                        </defs>
                        <path
                          className="cls-1"
                          d="M144,160a80,80,0,1,1,80-80A80,80,0,0,1,144,160Zm368,0a80,80,0,1,1,80-80A80,80,0,0,1,512,160ZM0,298.7A106.74,106.74,0,0,1,106.7,192h42.7a107.27,107.27,0,0,1,44.6,9.7,125.85,125.85,0,0,0-1.9,22.3,128,128,0,0,0,43.3,96H21.3A21.38,21.38,0,0,1,0,298.7ZM405.3,320h-.7a127.69,127.69,0,0,0,43.3-96,137,137,0,0,0-1.9-22.3,105.73,105.73,0,0,1,44.6-9.7h42.7A106.74,106.74,0,0,1,640,298.7,21.32,21.32,0,0,1,618.7,320ZM416,224a96,96,0,1,1-96-96A96,96,0,0,1,416,224ZM128,485.3A133.33,133.33,0,0,1,261.3,352H378.7A133.33,133.33,0,0,1,512,485.3,26.69,26.69,0,0,1,485.3,512H154.7A26.69,26.69,0,0,1,128,485.3Z"
                        />
                      </svg>
                      <strong>Excellent growth opportunities</strong>
                    </div>

                    <div className="jdTag_immediate jdTag active mt-2 text-primary-blue">
                      <svg
                        className="h-3 w-3 inline-block mr-1 "
                        id="Layer_1"
                        data-name="Layer 1"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512.05 448.1"
                      >
                        <defs>
                          <style></style>
                        </defs>
                        <path
                          className="cls-1"
                          d="M256,448c141.4,0,256-93.1,256-208S397.4,32,256,32,0,125.1,0,240c0,45.1,17.7,86.8,47.7,120.9-1.9,24.5-11.4,46.3-21.4,62.9a180.38,180.38,0,0,1-15.2,21.6c-2.1,2.5-3.7,4.4-4.9,5.7-.6.6-1,1.1-1.3,1.4l-.3.3h0a15.83,15.83,0,0,0-3.4,17.4A16,16,0,0,0,16,480.1c28.7,0,57.6-8.9,81.6-19.3,22.9-10,42.4-21.9,54.3-30.6A306.18,306.18,0,0,0,256,448.1ZM128,272a32,32,0,1,1,32-32A32,32,0,0,1,128,272Zm128,0a32,32,0,1,1,32-32A32,32,0,0,1,256,272Zm160-32a32,32,0,1,1-32-32A32,32,0,0,1,416,240Z"
                          transform="translate(0.05 -32)"
                        />
                      </svg>
                      <strong>Great Environment</strong>
                    </div>
                  </div>
                </div>

                <div className="JobDescription  min-sm:col-span-2 ">
                  <div className="tabs rounded-xl overflow-hidden ">
                    <div className="drop-shadow-lg ">
                      <div
                        id="tab-buttons"
                        className="flex max-md:flex-col max-md:gap-2 max-md:w-[97%]  "
                      >
                        <a
                          href="javascript:void(0)"
                          onClick={() => changeTab(0)}
                          className="inline-block min-sm:px-8 py-3 temanics-link-pointer max-sm:px-3 max-sm:py-1 font-semibold temanics-border-width border-primary-blue mr-1 rounded-tl-xl text-primary-white bg-primary-blue"
                        >
                          Job Description
                        </a>
                        <a
                          href="javascript:void(0)"
                          onClick={() => changeTab(1)}
                          className="inline-block min-sm:px-4 min-xl:px-8 py-3 max-sm:px-3 max-sm:py-1 
                        text-primary-blue font-semibold t-border-width t-border-primary-blue 
                        mr-1"
                        >
                          Responsibilities
                        </a>
                        <a
                          href="javascript:void(0)"
                          onClick={() => changeTab(2)}
                          className="inline-block min-sm:px-4 min-xl:px-8 py-3 max-sm:px-3 max-sm:py-1 
                        text-primary-blue font-semibold t-border-width t-border-primary-blue 
                        mr-1"
                        >
                          Requirements
                        </a>
                      </div>

                      <div
                        id="tab-panels"
                        className="bg-white px-12 pt-4 pb-7 t-border-width t-border-primary-blue rounded-b-xl  -mt-[1px] shadow-lg "
                      >
                        {/*Job Description */}
                        <div className="jobBox rounded-2xl">
                          <div className="text-base pt-5">
                            {!Stringutility.isNullOrEmpty(
                              response.jobDescription
                            ) && (
                              <p
                                className="pb-2"
                                dangerouslySetInnerHTML={{
                                  __html: response.jobDescription,
                                }}
                              ></p>
                            )}
                          </div>
                        </div>
                        {/*End of Job Description */}

                        {/*Job Responsibilities */}
                        <div className="jobBox hidden rounded-2xl">
                          <div className="text-base pt-5">
                            <ul className="marker:text-primary-blue list-caretright list-outside ">
                              {!Stringutility.isNullOrEmpty(
                                response.jobResponsibilities
                              ) && (
                                <p
                                  className="pb-2"
                                  dangerouslySetInnerHTML={{
                                    __html: response.jobResponsibilities,
                                  }}
                                ></p>
                              )}{" "}
                            </ul>
                          </div>
                        </div>
                        {/*End of Job Responsibilities */}

                        {/*Job Requirements */}
                        <div className="jobBox hidden rounded-2xl">
                          <div className="text-base pt-5">
                            <ul className="marker:text-primary-blue list-caretright list-outside ">
                              {!Stringutility.isNullOrEmpty(
                                response.jobRequirements
                              ) && (
                                <p
                                  className="pb-2"
                                  dangerouslySetInnerHTML={{
                                    __html: response.jobRequirements,
                                  }}
                                ></p>
                              )}
                            </ul>
                          </div>
                        </div>
                        {/*End of Job Requirements */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          );
        })}
     



<Modal
        id="exampleModal"
        isOpen={ModalBase}
        // closeModal={!ModalBase}
        // toggle={() => setModalBase(!ModalBase)}
        twrapClassName="modal-right"
        className="file-model-width"
        aria-hidden="true"
      >
       
        <ModalBody>
        <svg xmlns="http://www.w3.org/2000/svg"onClick={back} className="cancel_button" fill="#1F9DFC" height="1.5em" viewBox="0 0 448 512"><path d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm79 143c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"/></svg>
        {jobResponseList.length > 0 &&
        jobResponseList.map((response, index) => {
          return (
              <div key={index}
                className="JobDetails min-lg:col-span-3 
                                    min-lg:max-h-[70vh] 
                                    min-lg:px-4 max-lg:px-5
                                    hover:scrollbar-thin scrollbar-none pb-5"
              >
                <div className=" min-sm:col-span-2">
                  <div className="jobtitle">
                    <span className="text-[32px] font-semibold font-assistant ">
                      {response.publicTitle}
                    </span>
                    <p className="font-bold font-assistant">
                      {showAccount(response.account, response.address)}
                    </p>
                    
                    <div className="jdTag_immediate jdTag active mt-4 text-orange-400">
                      <svg
                        className="h-3 w-3 inline-block mr-1 "
                        fill="orange"
                        stroke="orange"
                        id="Layer_1"
                        data-name="Layer 1"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448.01 512"
                      >
                        <defs>
                          <style>.cls-1fill:orange;</style>
                        </defs>
                        <path
                          className="cls-1"
                          d="M224,0a32,32,0,0,0-32,32V51.2A160.07,160.07,0,0,0,64,208v18.8A192.46,192.46,0,0,1,15.5,354.4l-7.4,8.3A32,32,0,0,0,32,416H416a32,32,0,0,0,23.9-53.3l-7.4-8.3A192.27,192.27,0,0,1,384,226.8V208A160.07,160.07,0,0,0,256,51.2V32A32,32,0,0,0,224,0Zm45.3,493.3A64,64,0,0,0,288,448H160a64.06,64.06,0,0,0,109.3,45.3Z"
                          transform="translate(-0.02)"
                        ></path>
                      </svg>
                      <strong className="text-orange font-assistant">
                        Immediately hiring
                      </strong>
                    </div>
                  </div>

                  <div className="jobbrief_all border rounded-xl pt-3 pb-[10px] mb-3 mt-4 bg-primary-white/50 min-sm:-ml-1 font-assistant">
                    <div className="row">
                      {response.salaryMin !== 0 && response.salaryMax !== 0 ?  <div className="col-7">
                        <div className="jobbrief_salary  inline-block px-7 mb-3 ">
                          <strong className="text-[32px] font-semibold max-sm:text-[24px]">
                            {checkJobSalary(response)}
                          </strong>
                          <br />

                          {}
                          <span className="text-[18px] font-semibold font-assistant">
                            {showSalaryType(response.salaryType)}{" "}
                          </span>
                        </div>
                      </div>:<></>}
                     
                      <div className="col-5">
                        <div className="jobbrief_salary inline-block px-7 mt-1">
                          <strong className="text-[24px] font-semibold max-sm:text-[24px]">
                            {response.jobType.value}
                          </strong>
                          <br />
                          <span className="text-[18px] font-semibold font-assistant">
                            {response.workStatus.value}{" "}
                          </span>
                          <br />
                          <span className="text-sm font-light leading-3">
                            &nbsp;
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="jobbrief_info inline-block px-7 mb-3 min-sm:w-[100%]">
                      <strong className="text-[24px] font-semibold font-assistant">
                        Benefits
                      </strong>
                      <br />
                      <span className="text-sm inline-block min-sm:w-[81%] font-assistant">
                        {getJobBenefits(response.benefits)}
                      </span>
                      <br />
                      <div>
                        <strong className="text-[15px] font-semibold font-assistant">
                          Additional Benefits
                        </strong>
                        <span className="text-sm ml-1 inline-block min-sm:w-[81%] font-assistant">
                          {showAdditionalbenefits(response.benefits)}
                        </span>
                      </div>
                      
                      <br />
                      <a href={response.lpUrl}> <TeamanicsButton> Apply Now</TeamanicsButton></a>

                    </div>
                  </div>

                  <div className="jdTags flex flex-row min-sm:gap-3 ml-2 mb-4 max-sm:flex-col">
                    <div className="jdTag_immediate jdTag active mt-2 text-primary-blue">
                      <svg
                        className="h-4 w-4 inline-block mr-1 "
                        id="Layer_1"
                        data-name="Layer 1"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 640 512"
                      >
                        <defs>
                          <style></style>
                        </defs>
                        <path
                          className="cls-1"
                          d="M144,160a80,80,0,1,1,80-80A80,80,0,0,1,144,160Zm368,0a80,80,0,1,1,80-80A80,80,0,0,1,512,160ZM0,298.7A106.74,106.74,0,0,1,106.7,192h42.7a107.27,107.27,0,0,1,44.6,9.7,125.85,125.85,0,0,0-1.9,22.3,128,128,0,0,0,43.3,96H21.3A21.38,21.38,0,0,1,0,298.7ZM405.3,320h-.7a127.69,127.69,0,0,0,43.3-96,137,137,0,0,0-1.9-22.3,105.73,105.73,0,0,1,44.6-9.7h42.7A106.74,106.74,0,0,1,640,298.7,21.32,21.32,0,0,1,618.7,320ZM416,224a96,96,0,1,1-96-96A96,96,0,0,1,416,224ZM128,485.3A133.33,133.33,0,0,1,261.3,352H378.7A133.33,133.33,0,0,1,512,485.3,26.69,26.69,0,0,1,485.3,512H154.7A26.69,26.69,0,0,1,128,485.3Z"
                        />
                      </svg>
                      <strong>Excellent growth opportunities</strong>
                    </div>

                    <div className="jdTag_immediate jdTag active mt-2 text-primary-blue">
                      <svg
                        className="h-3 w-3 inline-block mr-1 "
                        id="Layer_1"
                        data-name="Layer 1"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512.05 448.1"
                      >
                        <defs>
                          <style></style>
                        </defs>
                        <path
                          className="cls-1"
                          d="M256,448c141.4,0,256-93.1,256-208S397.4,32,256,32,0,125.1,0,240c0,45.1,17.7,86.8,47.7,120.9-1.9,24.5-11.4,46.3-21.4,62.9a180.38,180.38,0,0,1-15.2,21.6c-2.1,2.5-3.7,4.4-4.9,5.7-.6.6-1,1.1-1.3,1.4l-.3.3h0a15.83,15.83,0,0,0-3.4,17.4A16,16,0,0,0,16,480.1c28.7,0,57.6-8.9,81.6-19.3,22.9-10,42.4-21.9,54.3-30.6A306.18,306.18,0,0,0,256,448.1ZM128,272a32,32,0,1,1,32-32A32,32,0,0,1,128,272Zm128,0a32,32,0,1,1,32-32A32,32,0,0,1,256,272Zm160-32a32,32,0,1,1-32-32A32,32,0,0,1,416,240Z"
                          transform="translate(0.05 -32)"
                        />
                      </svg>
                      <strong>Great Environment</strong>
                    </div>
                  </div>
                </div>

                <div className="JobDescription  min-sm:col-span-2 ">
                  <div className="tabs rounded-xl overflow-hidden ">
                    <div className="drop-shadow-lg ">
                      <div
                        id="tab-buttonsModal"
                        className="flex max-md:flex-col max-md:gap-2 max-md:w-[97%]  "
                      >
                        <a
                          href="javascript:void(0)"
                          onClick={() => changeTabModal(0)}
                          className="inline-block min-sm:px-8 py-3 temanics-link-pointer max-sm:px-3 max-sm:py-1 font-semibold temanics-border-width border-primary-blue mr-1 rounded-tl-xl text-primary-white bg-primary-blue"
                        >
                          Job Description
                        </a>
                        <a
                          href="javascript:void(0)"
                          onClick={() => changeTabModal(1)}
                          className="inline-block min-sm:px-4 min-xl:px-8 py-3 max-sm:px-3 max-sm:py-1 
                        text-primary-blue font-semibold t-border-width t-border-primary-blue 
                        mr-1"
                        >
                          Responsibilities
                        </a>
                        <a
                          href="javascript:void(0)"
                          onClick={() => changeTabModal(2)}
                          className="inline-block min-sm:px-4 min-xl:px-8 py-3 max-sm:px-3 max-sm:py-1 
                        text-primary-blue font-semibold t-border-width t-border-primary-blue 
                        mr-1"
                        >
                          Requirements
                        </a>
                      </div>

                      <div
                        id="tab-panelsModal"
                        className="bg-white px-12 pt-4 pb-7 t-border-width t-border-primary-blue rounded-b-xl  -mt-[1px] shadow-lg "
                      >
                        {/*Job Description */}
                        <div className="jobBox rounded-2xl">
                          <div className="text-base pt-5">
                            {!Stringutility.isNullOrEmpty(
                              response.jobDescription
                            ) && (
                              <p
                                className="pb-2"
                                dangerouslySetInnerHTML={{
                                  __html: response.jobDescription,
                                }}
                              ></p>
                            )}
                          </div>
                        </div>
                        {/*End of Job Description */}

                        {/*Job Responsibilities */}
                        <div className="jobBox hidden rounded-2xl">
                          <div className="text-base pt-5">
                            <ul className="marker:text-primary-blue list-caretright list-outside ">
                              {!Stringutility.isNullOrEmpty(
                                response.jobResponsibilities
                              ) && (
                                <p
                                  className="pb-2"
                                  dangerouslySetInnerHTML={{
                                    __html: response.jobResponsibilities,
                                  }}
                                ></p>
                              )}{" "}
                            </ul>
                          </div>
                        </div>
                        {/*End of Job Responsibilities */}

                        {/*Job Requirements */}
                        <div className="jobBox hidden rounded-2xl">
                          <div className="text-base pt-5">
                            <ul className="marker:text-primary-blue list-caretright list-outside ">
                              {!Stringutility.isNullOrEmpty(
                                response.jobRequirements
                              ) && (
                                <p
                                  className="pb-2"
                                  dangerouslySetInnerHTML={{
                                    __html: response.jobRequirements,
                                  }}
                                ></p>
                              )}
                            </ul>
                          </div>
                        </div>
                        {/*End of Job Requirements */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          );
        })}
       
        </ModalBody>

        {/* <ModalFooter className="model-button t-modal-footer-btn">
          <div>
            <TeamanicsButton onClick={back}>
              Close
            </TeamanicsButton>{" "}
          </div>
        </ModalFooter> */}
      </Modal>
      <div className="t-top-to-btm">
          {" "}
          {showTopBtn && (
            <FaAngleUp
              className="t-icon-position t-icon-style"
              onClick={goToTop}
            />
          )}{" "}
        </div>
 </> 





      
      
  
  );
};
export default FindJobsDescription;